import { render, staticRenderFns } from "./OrganizeMultiSelectTableModified2.vue?vue&type=template&id=5b7e19a9&scoped=true"
import script from "./OrganizeMultiSelectTableModified2.vue?vue&type=script&lang=js"
export * from "./OrganizeMultiSelectTableModified2.vue?vue&type=script&lang=js"
import style0 from "./OrganizeMultiSelectTableModified2.vue?vue&type=style&index=0&id=5b7e19a9&prod&scoped=true&lang=css"
import style1 from "./OrganizeMultiSelectTableModified2.vue?vue&type=style&index=1&id=5b7e19a9&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b7e19a9",
  null
  
)

export default component.exports